module.exports = __webpack_public_path__ + "img/17 juntos.db26e496.jpg";